import "./assets/scss/common.scss"
import "./assets/scss/timeline-switch.scss"
import "./assets/scss/table.scss"
import "./assets/scss/teeth.scss"
import "./assets/scss/search-filter.scss"
import "./assets/scss/date-picker.scss"
import "./assets/scss/ant-design-custom.scss"
import "./assets/scss/ant-design.scss"

export default {
  install() {},
};
